<template>
  <customizer-section title="Sizing">
    <template v-slot:icon>
      <div class="option-icon option-sizing" />
    </template>

    <div class="product-sizing">
      <!-- WIDTH OPTION -->
      <div class="product-sizing-col">
        <label>Width <i class="fas fa-arrows-alt-h"></i></label>

        <!-- whole width dropdown -->
        <ux-select
          :items="widthOptions"
          :value="cartItem.width.whole"
          @input="updateSize('width', 'whole', $event)"
        />

        <!-- fractional width dropdown -->
        <ux-select
          :items="fractionalOptions"
          :value="cartItem.width.fractional"
          @input="updateSize('width', 'fractional', $event)"
        />
      </div>

      <!-- HEIGHT OPTION -->
      <div class="product-sizing-col">
        <label>Height <i class="fas fa-arrows-alt-v"></i></label>

        <!-- whole height dropdown -->
        <ux-select
          :items="updatedHeightOptions"
          :value="cartItem.height.whole"
          @input="updateSize('height', 'whole', $event)"
        />

        <!-- fractional height dropdown -->
        <ux-select
          :items="fractionalOptions"
          :value="cartItem.height.fractional"
          @input="updateSize('height', 'fractional', $event)"
        />
      </div>
    </div>

    <ux-form-field label="Room Name (6 Character Limit)">
      <input
        type="text"
        class="ux-control is-inline"
        size="8"
        maxlength="6"
        :value="cartItem.room"
        @input="updateField('room', $event.target.value)"
      />
    </ux-form-field>
  </customizer-section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

import { fractionalSizeOptions } from "../options";

import CustomizerSection from "./CustomizerSection.vue";

export default {
  components: { CustomizerSection },

  computed: {
    ...mapGetters("customizer", [
      "productWidthOptions",
      "productHeightOptions",
    ]),
    ...mapState({
      cartItem: (state) => state.customizer.cartItem,
      product: (state) => state.customizer.product,
    }),

    // dropdown options for fractional inches
    fractionalOptions() {
      var opts = [];

      for (var key in fractionalSizeOptions)
        opts.push({ text: key, value: key });

      return opts;
    },

    // dropdown options to select width
    widthOptions() {
      return this.productWidthOptions.map((v) => ({ text: `${v}"`, value: v }));
    },

    // dropdown options to select height
    heightOptions() {
      return this.productHeightOptions.map((v) => ({
        text: `${v}"`,
        value: v,
      }));
    },

    updatedHeightOptions() {
      let maxAllowedHeightInches = 9999;
      let maxSqft = 40;
      // if product is faux blinds, restrict size to 40sqft
      if (
        this.$parent.$parent.productSlug &&
        this.$parent.$parent.productSlug.includes("faux")
      ) {
        const selectedWidthInches =
          Number(this.cartItem.width.whole) +
          Number(this.fractionToDecimal(this.cartItem.width.fractional));
        maxAllowedHeightInches = (maxSqft * 144) / selectedWidthInches; // Convert 40sqft to inches and divide by width
      }
      return this.heightOptions.filter((option) => {
        const optionInches = option.value + this.fractionToDecimal("1/8"); // Assuming smallest fractional part to ensure limit
        return optionInches <= maxAllowedHeightInches;
      });
    },
  },

  methods: {
    ...mapMutations("customizer", ["updateCartItem"]),

    fractionToDecimal(fractionString) {
      if (!fractionString.includes("/")) return 0;
      const [numerator, denominator] = fractionString.split("/").map(Number);
      return numerator / denominator;
    },

    // update cart item data
    updateField(field, value) {
      this.updateCartItem({ [field]: value });
    },

    // update width/height of cart item
    updateSize(field, param, value) {
      var setting = { ...this.cartItem[field], [param]: value };
      this.updateField(field, setting);
      console.log(this);
    },
  },
};
</script>
